<script>
  export let color = "black"
</script>

<span class="chip" style="--color: {color}">
  <slot />
</span>

<style>
  .chip {
    border-radius: 0.8rem;
    font-size: 0.8rem;
    border: 1px solid var(--color);
    padding: 0 0.2rem;
    color: var(--color);
    flex-shrink: 0;
    flex-grow: 0;
    background-color: white;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
  }
</style>
